"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionFormatter = optionFormatter;
var _react = _interopRequireDefault(require("react"));
var _OptionItem = require("../components/shared/OptionItem");
var _getOptionKey = require("./getOptionKey");
/**
 * This differs from the usual formatter in that it has some extra args for the selected option and handling members
 * @param option The option to be formatted
 * @param index The current array position of the option being rendered
 * @param highlightedIndex The index of the option that is currently *highlighted* - not selected
 * @param optionSpreadProps Pass through to the element root
 * @param isOptionSelected Boolean to determine if the option is selected
 * @param onViewMembers
 * @returns ReactElement
 */
function optionFormatter(option, singleOrMulti, index, highlightedIndex, optionSpreadProps, isOptionSelected, internalInputValue, portalProps, optionToString, onViewMembers) {
  let suppressContactCard = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
  return /*#__PURE__*/_react.default.createElement(_OptionItem.OptionItem, {
    key: (0, _getOptionKey.getOptionKey)(option),
    option: option,
    index: index,
    singleOrMulti: singleOrMulti,
    highlightedIndex: highlightedIndex,
    optionSpreadProps: optionSpreadProps,
    isOptionSelected: isOptionSelected,
    onViewMembers: onViewMembers,
    internalInputValue: internalInputValue,
    portalProps: portalProps,
    optionToString: optionToString,
    suppressContactCard: suppressContactCard
  });
}
//# sourceMappingURL=optionFormatter.js.map